import { render } from "./SiKaoOneView.vue?vue&type=template&id=199c497c&scoped=true&ts=true"
import script from "./SiKaoOneView.vue?vue&type=script&lang=ts"
export * from "./SiKaoOneView.vue?vue&type=script&lang=ts"

import "./SiKaoOneView.vue?vue&type=style&index=0&id=199c497c&lang=scss&scoped=true"

import exportComponent from "C:\\vue项目\\fushuliang\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-199c497c"]])

export default __exports__